/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/Filters/ProvidersAndAssistants/Content/Error"
  
}) {
  return null
}